import React from 'react'
import {
  Box,
  Button,
  Checkbox,
  DialogContentText,
  FormControlLabel,
  TextField,
} from '@mui/material'
import { GridRowsProp } from '@mui/x-data-grid'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { ShareReportsPayload } from 'gqlTypes'

interface Props {
  reports: GridRowsProp
  selectedReportIds: string[]
  emails: string
  includeBookmarks: boolean
  results?: ShareReportsPayload
  onGoBack: () => void
  onChange: (value: string) => void
  onToggleBookmarks: () => void
}

const ShareDialogEmails: React.FC<Props> = ({
  reports,
  selectedReportIds,
  emails,
  includeBookmarks,
  results,
  onGoBack,
  onChange,
  onToggleBookmarks,
}) => {
  let label =
    'Enter the email addresses for anyone with whom you would like to share reports (separate email addresses with commas).'
  if (reports.length > 1) {
    label = `2. ${label}`
  }

  return (
    <>
      {reports.length > 1 && (
        <Box mb={2}>
          <Button startIcon={<ArrowBackIcon />} onClick={onGoBack}>
            Select Reports
          </Button>
        </Box>
      )}
      <DialogContentText>{label}</DialogContentText>
      <TextField
        autoFocus
        margin="dense"
        id="emails"
        label={false}
        placeholder="example@email.com,example2@email.com"
        type="text"
        fullWidth
        multiline
        minRows={1}
        maxRows={4}
        variant="standard"
        value={emails || ''}
        error={results && !results.success}
        FormHelperTextProps={{ component: 'div' }}
        helperText={
          results &&
          !results.success && (
            <div dangerouslySetInnerHTML={{ __html: results.message }}></div>
          )
        }
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          onChange(event.target.value)
        }}
      />
      <FormControlLabel
        control={
          <Checkbox checked={includeBookmarks} onChange={onToggleBookmarks} />
        }
        label="Include Bookmarks"
      />
    </>
  )
}

export default ShareDialogEmails
